import { INVISIBLES } from '@workspace/constants/common.constant';

export const getHeadingAlignClass = (rawAlign: string | undefined) => {
  const normalizedAlign = (rawAlign || 'left').toString().replace(INVISIBLES, '').trim().toLowerCase() as
    | 'left'
    | 'center'
    | 'right';

  return normalizedAlign === 'center'
    ? 'justify-center'
    : normalizedAlign === 'right'
      ? 'justify-end'
      : 'justify-start';
};
